import React, { useState, useMemo } from 'react';
import { Button } from '@material-ui/core';
import styles from './Copy.module.scss';
import { FileCopy } from '@material-ui/icons';

const CopyTranscription = ({ transcription }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const htmlTranscript = transcription
      .map(
        ({ role, timestamp, content, name }) => `
        <div>
        <div style="display:flex;flex-direction:column;">
        <strong>${role === 'coach' ? 'AI Prospect' : role}-${name}</strong> 
        <span style="color:blue;">[${timestamp}]</span><br>
        </div>
        ${content}
        </div><br>
      `
      )
      .join('');

    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([htmlTranscript], { type: 'text/html' }),
          'text/plain': new Blob(
            [
              transcription
                .map(
                  (t) =>
                    `${t.role === 'coach' ? 'AI Prospect' : t.role} - ${t.name} [${t.timestamp}]\n${
                      t.content
                    }`
                )
                .join('\n\n'),
            ],
            { type: 'text/plain' }
          ),
        }),
      ]);
      setCopied(true);

      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };
  const isDisabled = useMemo(() => {
    if (!transcription || transcription?.length === 0) return true;
    return false;
  }, [transcription]);
  return (
    <div>
      <div className={styles.button}>
        <Button
          startIcon={<FileCopy fontSize="small" />}
          onClick={handleCopy}
          disabled={isDisabled}
        >
          Copy
        </Button>
      </div>
      {copied && <p style={{ color: 'green' }}>Copied!</p>}
    </div>
  );
};
export default CopyTranscription;
